import { useMemo } from 'react'
import { useLocation } from 'react-router'
import AppStore from '@v4/store/appStore'
import ScorecardSelector from '@v4/utils/selectors/ScorecardSelector'
import { useStoreState } from 'easy-peasy'
import QUESTION_TYPE, { QUESTION_REL_KEY } from '@v4/constants/questions'
import { getSignUpFormikProps, getAnswersFromQuery } from './Form.utils'

// eslint-disable-next-line import/prefer-default-export
export const useSignUpData = initialAnswers => {
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)
	const appData = AppStore.useStoreState(state => state.signUp.data)
	const builderData = useStoreState(state => state.signups.data)
	const settings = ScorecardSelector.useSettings()
	const data = useMemo(() => {
		if (!isBuilderMode) {
			return appData
		}
		return _.reduce(
			builderData,
			(acc, { options, ...item }) => {
				const relKEy = QUESTION_REL_KEY[item.answer_type]

				if (!acc[relKEy]) {
					return acc
				}

				acc[relKEy].push({
					...item,
					options:
						options &&
						options.map(option => ({
							id: option.id,
							option: option.option,
							is_custom: true,
						})),
				})

				return acc
			},
			{ [QUESTION_TYPE.CHECKBOX]: [], [QUESTION_TYPE.HIDDEN]: [], [QUESTION_TYPE.OTHER]: [] },
		)
	}, [appData, builderData, isBuilderMode])

	const { formikProps, prefillValues } = useMemo(() => {
		return getSignUpFormikProps(data, settings, initialAnswers)
	}, [data, initialAnswers, settings])

	return useMemo(
		() => ({
			data,
			settings,
			formikProps,
			prefillValues,
		}),
		[data, formikProps, prefillValues, settings],
	)
}

export const useQueryInitialAnswers = () => {
	const { search } = useLocation()
	return useMemo(() => getAnswersFromQuery(search), [search])
}

export const useResultInitialAnswers = () => {
	const { first_name: firstName, last_name: lastName, email, opt_in: optIn } = AppStore.useStoreState(
		state => state.result.data,
	)
	const answers = AppStore.useStoreState(state => state.signUp.answers)

	return useMemo(
		() =>
			answers.reduce(
				(acc, answer) => {
					const value = answer.option_id || answer.answer
					if (value) {
						acc[answer.question_id] = value
					}

					return acc
				},
				{
					first_name: firstName,
					last_name: lastName,
					email,
					opt_in: optIn,
				},
			),
		[answers, email, firstName, lastName, optIn],
	)
}
